export default __webpack_public_path__ + "static/media/location-marker-gray.0858edb6.svg";